unit View.Desoneracao_Icms.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewDesoneracao_IcmsEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbdesoneracao_icms_id: TLabel;
    eddesoneracao_icms_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientDesoneracao_IcmsGet: TXDataWebClient;
    XDataClientDesoneracao_IcmsDelete: TXDataWebClient;
    Desoneracao_IcmsDataset: TXDataWebDataSet;
    Desoneracao_IcmsDatasetdesoneracao_icms_id: TIntegerField;
    Desoneracao_IcmsDatasetnome: TStringField;
    Desoneracao_IcmsDatasetexcluido: TBooleanField;
    Desoneracao_IcmsDatasetinclusao: TDateTimeField;
    Desoneracao_IcmsDatasetalteracao: TDateTimeField;
    Desoneracao_IcmsDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientDesoneracao_IcmsGetLoad(Response: TXDataClientResponse);
    procedure XDataClientDesoneracao_IcmsDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientDesoneracao_IcmsDeleteError(Error: TXDataClientError);
    procedure Desoneracao_IcmsDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewDesoneracao_IcmsEdit: TFViewDesoneracao_IcmsEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewDesoneracao_IcmsEdit }

procedure TFViewDesoneracao_IcmsEdit.btSaveClick(Sender: TObject);
begin
  if Desoneracao_IcmsDataset.State in dsEditModes then
  begin
        Desoneracao_IcmsDataset.Post;
    Desoneracao_IcmsDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewDesoneracao_IcmsEdit.btDeleteClick(Sender: TObject);
begin
  if Desoneracao_IcmsDataset.State in dsEditModes then
    Desoneracao_IcmsDataset.Post;
  XDataClientDesoneracao_IcmsDelete.Delete(Desoneracao_IcmsDataset.EntitySetName,
    TJSObject(Desoneracao_IcmsDataset.CurrentData));
end;


class function TFViewDesoneracao_IcmsEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewDesoneracao_IcmsEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewDesoneracao_IcmsEdit.InsertEntity;
begin
  Desoneracao_IcmsDataset.Close;
  Desoneracao_IcmsDataset.SetJsonData('{}');
  Desoneracao_IcmsDataset.Open;
  Desoneracao_IcmsDataset.Insert;
end;

class function TFViewDesoneracao_IcmsEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewDesoneracao_IcmsEdit(AForm).FInserting := AInserting;
    TFViewDesoneracao_IcmsEdit(AForm).FId := AId;
    TFViewDesoneracao_IcmsEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewDesoneracao_IcmsEdit(AForm).InsertEntity
    else
      TFViewDesoneracao_IcmsEdit(AForm).LoadEntity;
    TFViewDesoneracao_IcmsEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewDesoneracao_IcmsEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewDesoneracao_IcmsEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Desoneracao_IcmsDataset.Connection.Model.DefaultSchema.FindEntityType(
      Desoneracao_IcmsDataset.EntitySetName
    )
  );
  XDataClientDesoneracao_IcmsGet.Get(Desoneracao_IcmsDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewDesoneracao_IcmsEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewDesoneracao_IcmsEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewDesoneracao_IcmsEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewDesoneracao_IcmsEdit.XDataClientDesoneracao_IcmsGetLoad(Response: TXDataClientResponse);
begin
  Desoneracao_IcmsDataset.Close;
  Desoneracao_IcmsDataset.SetJsonData(Response.Result);
  Desoneracao_IcmsDataset.Open;
  
  Desoneracao_IcmsDataset.Edit;  
end;

procedure TFViewDesoneracao_IcmsEdit.XDataClientDesoneracao_IcmsDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewDesoneracao_IcmsEdit.XDataClientDesoneracao_IcmsDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewDesoneracao_IcmsEdit.Desoneracao_IcmsDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewDesoneracao_IcmsEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewDesoneracao_IcmsEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.desoneracao_icms.form.message');
  lbMessage := TLabel.Create('view.desoneracao_icms.form.message.label');
  btCloseMessage := TButton.Create('view.desoneracao_icms.form.message.button');
  btCancel := TButton.Create('view.desoneracao_icms.form.btBack');
  btSave := TButton.Create('view.desoneracao_icms.form.btSave');
  btDelete := TButton.Create('view.desoneracao_icms.form.btDelete');
  lbdesoneracao_icms_id := TLabel.Create('view.desoneracao_icms.form.lbdesoneracao_icms_id');
  eddesoneracao_icms_id := TDBEdit.Create('view.desoneracao_icms.form.eddesoneracao_icms_id');
  lbnome := TLabel.Create('view.desoneracao_icms.form.lbnome');
  ednome := TDBEdit.Create('view.desoneracao_icms.form.ednome');
  lbexcluido := TLabel.Create('view.desoneracao_icms.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.desoneracao_icms.form.edexcluido');
  lbinclusao := TLabel.Create('view.desoneracao_icms.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.desoneracao_icms.form.edinclusao');
  lbalteracao := TLabel.Create('view.desoneracao_icms.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.desoneracao_icms.form.edalteracao');
  lbexclusao := TLabel.Create('view.desoneracao_icms.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.desoneracao_icms.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Desoneracao_IcmsDataset := TXDataWebDataSet.Create(Self);
  Desoneracao_IcmsDatasetdesoneracao_icms_id := TIntegerField.Create(Self);
  Desoneracao_IcmsDatasetnome := TStringField.Create(Self);
  Desoneracao_IcmsDatasetexcluido := TBooleanField.Create(Self);
  Desoneracao_IcmsDatasetinclusao := TDateTimeField.Create(Self);
  Desoneracao_IcmsDatasetalteracao := TDateTimeField.Create(Self);
  Desoneracao_IcmsDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientDesoneracao_IcmsGet := TXDataWebClient.Create(Self);
  XDataClientDesoneracao_IcmsDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbdesoneracao_icms_id.BeforeLoadDFMValues;
  eddesoneracao_icms_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Desoneracao_IcmsDataset.BeforeLoadDFMValues;
  Desoneracao_IcmsDatasetdesoneracao_icms_id.BeforeLoadDFMValues;
  Desoneracao_IcmsDatasetnome.BeforeLoadDFMValues;
  Desoneracao_IcmsDatasetexcluido.BeforeLoadDFMValues;
  Desoneracao_IcmsDatasetinclusao.BeforeLoadDFMValues;
  Desoneracao_IcmsDatasetalteracao.BeforeLoadDFMValues;
  Desoneracao_IcmsDatasetexclusao.BeforeLoadDFMValues;
  XDataClientDesoneracao_IcmsGet.BeforeLoadDFMValues;
  XDataClientDesoneracao_IcmsDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewDesoneracao_IcmsEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 427;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 367;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 367;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 367;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbdesoneracao_icms_id.SetParentComponent(Self);
    lbdesoneracao_icms_id.Name := 'lbdesoneracao_icms_id';
    lbdesoneracao_icms_id.Left := 24;
    lbdesoneracao_icms_id.Top := 192;
    lbdesoneracao_icms_id.Width := 14;
    lbdesoneracao_icms_id.Height := 13;
    lbdesoneracao_icms_id.Caption := 'desoneracao_icms_id:';
    lbdesoneracao_icms_id.Transparent := True;
    eddesoneracao_icms_id.SetParentComponent(Self);
    eddesoneracao_icms_id.Name := 'eddesoneracao_icms_id';
    eddesoneracao_icms_id.Left := 221;
    eddesoneracao_icms_id.Top := 189;
    eddesoneracao_icms_id.Width := 200;
    eddesoneracao_icms_id.Height := 21;
    eddesoneracao_icms_id.Enabled := True;
    eddesoneracao_icms_id.TabOrder := 6;
    eddesoneracao_icms_id.Text := 'eddesoneracao_icms_id';
    eddesoneracao_icms_id.DataField := 'desoneracao_icms_id';
    eddesoneracao_icms_id.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 219;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 216;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 7;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 246;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 243;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 8;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 273;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 270;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 9;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 300;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 297;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 10;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 327;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 324;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 11;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Desoneracao_IcmsDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Desoneracao_IcmsDataset.SetParentComponent(Self);
    Desoneracao_IcmsDataset.Name := 'Desoneracao_IcmsDataset';
    Desoneracao_IcmsDataset.AfterApplyUpdates := Desoneracao_IcmsDatasetAfterApplyUpdates;
    Desoneracao_IcmsDataset.EntitySetName := 'Desoneracao_Icms';
    Desoneracao_IcmsDataset.Connection := DMConnection.ApiConnection;
    Desoneracao_IcmsDataset.Left := 176;
    Desoneracao_IcmsDataset.Top := 8;
    Desoneracao_IcmsDatasetdesoneracao_icms_id.SetParentComponent(Desoneracao_IcmsDataset);
    Desoneracao_IcmsDatasetdesoneracao_icms_id.Name := 'Desoneracao_IcmsDatasetdesoneracao_icms_id';
    Desoneracao_IcmsDatasetdesoneracao_icms_id.FieldName := 'desoneracao_icms_id';
    Desoneracao_IcmsDatasetdesoneracao_icms_id.Required := True;
    Desoneracao_IcmsDatasetnome.SetParentComponent(Desoneracao_IcmsDataset);
    Desoneracao_IcmsDatasetnome.Name := 'Desoneracao_IcmsDatasetnome';
    Desoneracao_IcmsDatasetnome.FieldName := 'nome';
    Desoneracao_IcmsDatasetnome.Required := True;
    Desoneracao_IcmsDatasetnome.Size := 255;
    Desoneracao_IcmsDatasetexcluido.SetParentComponent(Desoneracao_IcmsDataset);
    Desoneracao_IcmsDatasetexcluido.Name := 'Desoneracao_IcmsDatasetexcluido';
    Desoneracao_IcmsDatasetexcluido.FieldName := 'excluido';
    Desoneracao_IcmsDatasetexcluido.Required := False;
    Desoneracao_IcmsDatasetinclusao.SetParentComponent(Desoneracao_IcmsDataset);
    Desoneracao_IcmsDatasetinclusao.Name := 'Desoneracao_IcmsDatasetinclusao';
    Desoneracao_IcmsDatasetinclusao.FieldName := 'inclusao';
    Desoneracao_IcmsDatasetinclusao.Required := False;
    Desoneracao_IcmsDatasetalteracao.SetParentComponent(Desoneracao_IcmsDataset);
    Desoneracao_IcmsDatasetalteracao.Name := 'Desoneracao_IcmsDatasetalteracao';
    Desoneracao_IcmsDatasetalteracao.FieldName := 'alteracao';
    Desoneracao_IcmsDatasetalteracao.Required := False;
    Desoneracao_IcmsDatasetexclusao.SetParentComponent(Desoneracao_IcmsDataset);
    Desoneracao_IcmsDatasetexclusao.Name := 'Desoneracao_IcmsDatasetexclusao';
    Desoneracao_IcmsDatasetexclusao.FieldName := 'exclusao';
    Desoneracao_IcmsDatasetexclusao.Required := False;
    XDataClientDesoneracao_IcmsGet.SetParentComponent(Self);
    XDataClientDesoneracao_IcmsGet.Name := 'XDataClientDesoneracao_IcmsGet';
    XDataClientDesoneracao_IcmsGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientDesoneracao_IcmsGet, Self, 'OnLoad', 'XDataClientDesoneracao_IcmsGetLoad');
    XDataClientDesoneracao_IcmsGet.Left := 64;
    XDataClientDesoneracao_IcmsGet.Top := 8;
    XDataClientDesoneracao_IcmsDelete.SetParentComponent(Self);
    XDataClientDesoneracao_IcmsDelete.Name := 'XDataClientDesoneracao_IcmsDelete';
    XDataClientDesoneracao_IcmsDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientDesoneracao_IcmsDelete, Self, 'OnLoad', 'XDataClientDesoneracao_IcmsDeleteLoad');
    SetEvent(XDataClientDesoneracao_IcmsDelete, Self, 'OnError', 'XDataClientDesoneracao_IcmsDeleteError');
    XDataClientDesoneracao_IcmsDelete.Left := 64;
    XDataClientDesoneracao_IcmsDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbdesoneracao_icms_id.AfterLoadDFMValues;
    eddesoneracao_icms_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Desoneracao_IcmsDataset.AfterLoadDFMValues;
    Desoneracao_IcmsDatasetdesoneracao_icms_id.AfterLoadDFMValues;
    Desoneracao_IcmsDatasetnome.AfterLoadDFMValues;
    Desoneracao_IcmsDatasetexcluido.AfterLoadDFMValues;
    Desoneracao_IcmsDatasetinclusao.AfterLoadDFMValues;
    Desoneracao_IcmsDatasetalteracao.AfterLoadDFMValues;
    Desoneracao_IcmsDatasetexclusao.AfterLoadDFMValues;
    XDataClientDesoneracao_IcmsGet.AfterLoadDFMValues;
    XDataClientDesoneracao_IcmsDelete.AfterLoadDFMValues;
  end;
end;

end.
